import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support-container',
  templateUrl: './support-container.component.html',
  styleUrls: ['./support-container.component.css']
})
export class SupportContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
